import { useEffect } from 'react';

/**
 * DevToolsProtection
 *
 * Previously this component attempted to block developer tools,
 * right‑click, keyboard shortcuts and even redirected users.
 *
 * This can hurt UX and interfere with search engine rendering,
 * so it is now a no‑op that only logs once in development.
 */
const DevToolsProtection = () => {
  useEffect(() => {
    if (!import.meta.env.PROD) {
      // In development, you can keep this log if you want to see
      // that the component is mounted.
      // eslint-disable-next-line no-console
      console.info('DevToolsProtection mounted (no-op in this version).');
    }
  }, []);

  return null;
};

export default DevToolsProtection;
